import React, {Fragment} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {Autocomplete, CircularProgress, TextField} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {RequestErrorModal} from 'presentation/pages/private/refund/components';
import {useGetCities} from '../../../../hooks/useGetCities';
import {CityAutoCompleteProps} from './types';

const {cityPlaceholder} =
	translations['pt-br'].privateFlow.refund.receiptRegistrationPage.fiscalDocument;

const {loading: loadingText, notFound: notFoundText} = translations['pt-br'].privateFlow.refund;
const {requiredField} = translations['pt-br'].commons;

export const CityAutoComplete = ({name, error}: CityAutoCompleteProps) => {
	const {control, watch} = useFormContext();
	const state = watch('state');
	const {loadingList, options, open, handleClose, handleOpen, setFetchError, fetchError} =
		useGetCities(state?.code ?? '');

	return (
		<Fragment>
			<Controller
				control={control}
				name={name}
				render={({field: {value, onChange}, fieldState: {invalid}}) => {
					const showCityError = state && (invalid || !!error);
					const showCityErrorMessage = showCityError ? requiredField : null;

					return (
						<Autocomplete
							disabled={!state}
							open={open}
							onOpen={handleOpen}
							onClose={handleClose}
							onChange={(_event, selectedOptions) => {
								onChange(selectedOptions);
							}}
							value={value?.citycode ? value : null}
							isOptionEqualToValue={(option, valueOption) =>
								option?.citycode === valueOption?.citycode
							}
							getOptionLabel={option => (option ? formatText(option?.city) : '')}
							options={options ?? []}
							loading={loadingList}
							loadingText={loadingText}
							noOptionsText={notFoundText}
							renderInput={params => (
								<TextField
									{...params}
									error={showCityError}
									placeholder={cityPlaceholder}
									label={cityPlaceholder}
									slotProps={{
										input: {
											...params?.InputProps,
											endAdornment: (
												<Fragment>
													{loadingList ? (
														<CircularProgress color="inherit" size={20} />
													) : null}
													{params?.InputProps?.endAdornment}
												</Fragment>
											),
										},
									}}
									helperText={showCityErrorMessage}
								/>
							)}
						/>
					);
				}}
			/>

			<RequestErrorModal open={fetchError} setOpen={setFetchError} />
		</Fragment>
	);
};
